<script>
  import Subsection from "../../../../../components/layout/Subsection.svelte";
  import SubsectionTitle from "../../../../../components/layout/SubsectionTitle.svelte";
  import PrimaryBorderedButton from "../../../../../components/button/generic/PrimaryBorderedButton.svelte";
  import { getContext } from "svelte"
  import { FetchError } from "../../../../../utils/getData.js";
  import { logoutOnlineLicense } from "../../../../../utils/onlineLicense.js";
  import {translate} from "../../../../../i18n/i18next.js";

  export let closeDialog

  const {handleNonBlockingFetchErrors} = getContext("fetchErrorHandler")

  async function onClickLogout() {
    try {
      await logoutOnlineLicense()
      closeDialog()
    } catch (e) {
      if (e instanceof FetchError) {
        handleNonBlockingFetchErrors(e.error)
      }
    }
  }
</script>

<Subsection>
  <SubsectionTitle>
    {translate("frontend:components.manageLicenseAuthenticationDialog.onlineLicense.logout.title")}
  </SubsectionTitle>
  <div class="subsection-content-caption">
    {translate("frontend:components.manageLicenseAuthenticationDialog.onlineLicense.logout.caption")} <br/>
    <span style="color:crimson">
      {translate("frontend:components.manageLicenseAuthenticationDialog.onlineLicense.logout.warning")}
    </span>
  </div>
  <div class="subsection-content-button">
    <PrimaryBorderedButton onClick={onClickLogout}>
      {translate("generic.logout")}
    </PrimaryBorderedButton>
  </div>
</Subsection>

<style>
  .subsection-content-button {
    align-self: end;
  }
</style>
